export const visit = (vm, at) => {
at({ "nl": { "conversations-visitor-experience-components": { "code-splitting": { "error": { "title": "Er was een probleem met de netwerkverbinding.", "message": "Controleer je verbinding en probeer het opnieuw.", "button": "Opnieuw proberen" } } } } });
};